function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withRouter } from "next/router";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureWithLinkComponent from "components/core/picture-with-link/picture-with-link-component";
import SecondaryLinkItemComponent from "segments/desktop/header/layouts/base-header/secondary-header/secondary-link-item/secondary-link-item-component";
import { getMiniSiteLinks, getMiniSiteLogo } from "client/services/cluster-config-service/cluster-config-service";
import { hasDomain, isSameUrlWithoutQueryParams } from "utils/url";
import { StyledSecondaryHeaderDesktopComponent } from "./secondary-header-desktop-component.scss";
class SecondaryHeaderDesktopComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledSecondaryHeaderDesktopComponent, {
            "aria-label": "Secondary",
            className: "secondary-header-desktop-component",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "secondary-header-desktop-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "logo-wrapper",
                        children: this.renderLogo()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "links-wrapper",
                        children: this.renderLinks()
                    })
                ]
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderLogo", ()=>{
            const { pageClusterConfig, useProductMiniSiteConfig } = this.props;
            const logo = getMiniSiteLogo(pageClusterConfig, {
                useProductMiniSiteConfig
            });
            return /*#__PURE__*/ _jsx(PictureWithLinkComponent, {
                className: "secondary-header-logo-image",
                src: logo === null || logo === void 0 ? void 0 : logo.src,
                alt: logo === null || logo === void 0 ? void 0 : logo.alt,
                href: logo === null || logo === void 0 ? void 0 : logo.url
            });
        });
        _define_property(this, "renderLinks", ()=>{
            const { pageClusterConfig, router, useProductMiniSiteConfig, headerCatalogLinks } = this.props;
            const links = getMiniSiteLinks(pageClusterConfig, {
                useProductMiniSiteConfig
            });
            return links.map((link, index)=>{
                var _headerCatalogLinks_link_url;
                const resolvedUrl = hasDomain(link === null || link === void 0 ? void 0 : link.url) ? link === null || link === void 0 ? void 0 : link.url : (_headerCatalogLinks_link_url = headerCatalogLinks === null || headerCatalogLinks === void 0 ? void 0 : headerCatalogLinks[link === null || link === void 0 ? void 0 : link.url]) !== null && _headerCatalogLinks_link_url !== void 0 ? _headerCatalogLinks_link_url : link === null || link === void 0 ? void 0 : link.url;
                return /*#__PURE__*/ _jsx("div", {
                    className: "secondary-link-item-wrapper",
                    children: /*#__PURE__*/ _jsx(SecondaryLinkItemComponent, {
                        url: resolvedUrl,
                        title: link === null || link === void 0 ? void 0 : link.text,
                        isSelected: isSameUrlWithoutQueryParams(resolvedUrl, router === null || router === void 0 ? void 0 : router.asPath)
                    })
                }, index);
            });
        });
    }
}
export default withRouter(withGenericConfig(SecondaryHeaderDesktopComponent));
